<script>
  import { _ } from "svelte-i18n";
  import { onMount } from "svelte";
  import {
    currentPage,
    activationCode,
    invitationNumber,
    showCompletedSelection,
  } from "../../utilities/DataStore";
  import { router } from "tinro";

  export let instanceId;
  export let instanceData;

  const dateOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };

  function initialize() {
    console.log(instanceData);
  }

  onMount(() => {
    initialize();
  });

  function shareButton() {
    if (navigator.share) {
      navigator
        .share({
          title: "Share Sensay Assessment Report",
          url: `https://assessment.oksensay.com/#/certificate/${instanceId}`,
        })
        .then(() => {
          console.log("Thanks for sharing!");
        })
        .catch(console.error);
    } else {
      copyLink();
    }
  }

  let linkCopied = false;

  let timer;

  const debounce = (v) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      linkCopied = false;
    }, 5000);
  };

  function copyLink() {
    let url = `https://assessment.oksensay.com/#/certificate/${instanceId}`;
    copyTextToClipboard(url);
  }

  function copyTextToClipboard(text) {
    linkCopied = true;
    debounce();
    navigator.clipboard.writeText(text).then(
      function () {
        console.log("Async: Copying to clipboard was successful!");
      },
      function (err) {
        console.error("Async: Could not copy text: ", err);
      },
    );
  }

  function backToSelection() {
    $showCompletedSelection = true;
    router.goto("/");
    $currentPage = "AssessmentSelection";
  }
</script>

<div class="thank-you-page">
  <div class="row justify-content-center">
    <div class="col-auto">
      <div class="mb-4">
        <span
          ><a href="https://www.oksensay.com/blog/assessment"
            ><img
              style="margin-right: 1em;"
              src="assets/img/logo_horizontal_nobg2.png"
              alt="OksenSay"
            /></a
          ></span
        >
      </div>
    </div>
  </div>

  <div class="row mt-4 justify-content-center">
    <div class="col-auto">
      <p class="text">
      {$_("RESULT_REPORT_NO_DATA")}        
      </p>
    </div>
  </div>

  {#if $activationCode || $invitationNumber}
    <div class="row mt-4 justify-content-center">
      <div class="col-auto">
        <button class="btn-teal" on:click={backToSelection}
          >{$_("BACK_TO_SELECTION")}</button
        >
      </div>
    </div>
  {/if}
</div>

<style>
  .thank-you-page {
    max-width: 700px;
    margin: 3rem auto;
    padding: 3rem 2rem;
    text-align: center;
  }

  .text {
    font-size: 1.05rem;
    color: #374151;
    line-height: 1.7;
    max-width: 540px;
    margin: 0 auto;
  }

  .btn-teal {
    background-color: #00a094;
    color: #ffffff;
    border: none;
    padding: 0.75rem 2rem;
    font-size: 1rem;
    font-weight: 700;
    border-radius: 8px;
    cursor: pointer;
    box-shadow: 0 5px 12px rgba(0, 152, 135, 0.32);
    transition: filter 0.2s ease, transform 0.2s ease;
  }

  .btn-teal:hover {
    filter: brightness(1.06);
    transform: translateY(-1px);
  }
</style>
